import React from "react";
import "./LoginServiceApp.scss";
import { LoginDebtId } from "./modules/loginDebtId/LoginDebtId";
import { Panel } from "spot-component-library/src/components/basic/panel/Panel";
import { LoginBox } from "./modules/loginBox/loginBox";
import AppContainer from "spot-component-library/src/components/layout/app-container/AppContainer";

function LoginServiceApp() {
    return (
        <AppContainer header={{ menuLoginEnabled: false }}>
            <div className="main-wrapper">
                <Panel>
                    <LoginDebtId />
                </Panel>
                <br />
                <br />
                <Panel>
                    <LoginDebtId buttonText="Prüfen" buttonPosition={"Right"} />
                </Panel>
                <br />
                <br />

                <LoginBox buttonLinkUrl="./payments/#paymentStep2" />
            </div>
        </AppContainer>
    );
}

export default LoginServiceApp;
